import {atom} from "@reatom/core";

class Store {
  ctx = null

  state = atom({})

  constructor(ctx) {
    this.ctx = ctx
  }

  get(key, defaultValue) {
    const state = this.ctx.get(this.state)
    return state[key] ?? defaultValue
  }

  set(key, value) {
    const state = this.ctx.get(this.state)
    state[key] = value
    this.state(this.ctx, {...state})
    return value
  }

  remove(key) {
    const state = this.ctx.get(this.state)
    delete state[key]
    this.state(this.ctx, ...state)
  }

  getState() {
    return this.ctx.get(this.state)
  }

  onSpy(ctx) {
    ctx.spy(this.state)
  }
}

export default Store